import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../../components/layout/TopBar';
import { Button, PasswordField } from '../../components/common';
import profileApi from '../../api/profile/profileApi';
import { useToast } from '../../context/ToastContext';
import * as v from '../../utils/validators';

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const toast = useToast();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    const errs = v.validate(form, {
      currentPassword: (x) => v.required(x, 'Current password'),
      newPassword: v.password,
      confirm: (c, all) => (c === all.newPassword ? '' : 'Passwords don’t match'),
    });
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setSaving(true);
    try {
      await profileApi.changePassword(form);
      toast.show('Password updated');
      navigate(-1);
    } catch (ex) {
      setErrors(ex.errors || { currentPassword: ex.message });
      setSaving(false);
    }
  };

  return (
    <div className="page page--white">
      <TopBar title="Change password" bordered />
      <form className="page__body" onSubmit={submit} noValidate>
        <PasswordField label="Current password" autoComplete="current-password" value={form.currentPassword} onChange={set('currentPassword')} error={errors.currentPassword} />
        <PasswordField label="New password" autoComplete="new-password" placeholder="At least 8 characters" value={form.newPassword} onChange={set('newPassword')} error={errors.newPassword} />
        <PasswordField label="Confirm new password" autoComplete="new-password" value={form.confirm} onChange={set('confirm')} error={errors.confirm} />
        <Button type="submit" block className="u-mt-6" loading={saving}>Update password</Button>
      </form>
    </div>
  );
}
